import { api } from '../api/client';
import { useAuthStore } from '../stores/auth';
import type { SessionUser, AuthTokens } from '@sundkortid/shared';

export async function refreshAccessToken(): Promise<string | null> {
  try {
    const result = await api.post<AuthTokens>('/auth/refresh');
    useAuthStore.getState().setAccessToken(result.accessToken);
    return result.accessToken;
  } catch {
    useAuthStore.getState().logout();
    return null;
  }
}

export async function initAuth(): Promise<void> {
  const store = useAuthStore.getState();
  try {
    const token = await refreshAccessToken();
    if (token) {
      const user = await api.get<SessionUser>('/users/me');
      store.setUser(user);
    }
  } catch {
    store.logout();
  } finally {
    store.setLoading(false);
  }
}
